import type { GlobalState } from '../types';
import type { SharedState } from '../types/sharedState';

export function updateSharedState<T extends GlobalState>(
  global: T, update: Partial<SharedState>,
): T {
  const newSharedState = {
    ...global.sharedState,
    ...update,
  };

  // Sync sharedState.settings to global.settings for backward compatibility
  // But preserve per-account settings like themes, loadedWallpapers, privacy
  const syncedSettings = update.settings ? {
    ...global.settings,
    byKey: {
      ...global.settings.byKey,
      ...update.settings,
    },
    performance: update.settings.performance ?? global.settings.performance,
  } : global.settings;

  return {
    ...global,
    sharedState: newSharedState,
    settings: syncedSettings,
  };
}
